export default __webpack_public_path__ + "static/media/big.7239b79f.png";